import { useEffect, useState } from "react";
import { supabase } from "../../../../lib/supabase/supabaseClient";
import { Logger } from "../../../../lib/logger/Logger";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import { showNotification } from "../../store/Central/selectors";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../../components/src/animations/loading";
import { useCentralStore } from "../../store/Central";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const Login = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState(false);
	const { profile, initialize } = useCentralStore();
	const navigate = useNavigate();

	useEffect(() => {
		if (profile) {
			navigate("/patients");
			return;
		}
	}, [profile]);

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setLoading(true);

		const formData: any = new FormData(event.currentTarget);

		try {
			const { data, error } = await supabase.auth.signInWithPassword({
				email: formData.get("email") as string,
				password: formData.get("password") as string,
			});

			if (data.session) {
				await initialize();
				Logger.log("Set session after sign in");
				navigate("/patients");
			}
			if (error) {
				showNotification({
					message:
						"Falsche Anmeldedaten. Bitte versuchen Sie es erneut.",
					type: "error",
				});
			}
		} catch (error: any) {
			showNotification({
				message: "Falscher Benutzername oder Passwort",
				type: "error",
			});
		} finally {
			setLoading(false);
			Logger.log("Sign in complete");
			navigate("/patients");
		}
	};

	const handleTogglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<form onSubmit={handleSubmit}>
			<div className="flex px-8 gap-4 justify-center items-center flex-col">
				<div className="text-3xl font-bold pt-8">Willkommen zurück!</div>

				<div className="text-xl">
					Melden Sie sich mit Ihren dentLAB-Daten an.
				</div>

				<TextField required fullWidth name="email" label="Email" />
				<TextField
					required
					fullWidth
					type={showPassword ? "text" : "password"}
					name="password"
					label="Passwort"
					slotProps={{
						input: {
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={handleTogglePasswordVisibility}
										edge="end"
									>
										{showPassword ? (
											<VisibilityOff />
										) : (
											<Visibility />
										)}
									</IconButton>
								</InputAdornment>
							),
						},
					}}
				/>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					sx={{
						mt: 3,
						mb: 2,
						color: "white",
						backgroundColor: "#003261",

						"&:transition-colors active": {
							backgroundColor: "#00284e",
						},
					}}
				>
					{loading ? <Loading /> : "Anmelden"}
				</Button>
			</div>
		</form>
	);
};
